import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import { SxProps, Typography } from '@mui/material';
import { stripHtmlTags } from '@/utils/stripHtmlTags';

interface Props {
	label: string;
	href?: string;
	sx?: SxProps;
	searchMatch: string;
	onClick?: () => void;
}

const highlightSearchMatch = (text: string, searchMatch: string) => {
	if (!searchMatch || searchMatch.trim() === '') {
		return text;
	}

	const regex = new RegExp(`(${searchMatch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
	const parts = text.split(regex);

	return parts.map((part, index) => {
		const isMatch = regex.test(part);
		regex.lastIndex = 0;

		return isMatch ? (
			<Typography key={index} component="span" variant="inherit" sx={{ fontWeight: 'bold' }}>
				{part}
			</Typography>
		) : (
			part
		);
	});
};

export const HeaderNavBarSuggest: React.FC<Props> = ({ label, href, sx, searchMatch, onClick }) => (
	<Linkable
		href={href}
		type="inline"
		sx={combineSX([
			{
				fontSize: { xs: 'var(--font-size-sm)', md: 'var(--font-size-default)' },
				fontWeight: 'normal',
				color: '#2C2C2C',
				letterSpacing: '0px',
				textDecoration: 'none',
				'&:hover': { textDecoration: 'underline', color: '#2C2C2C' },
				cursor: 'pointer',
			},
			...(Array.isArray(sx) ? sx : [sx]),
		])}
		onClick={onClick}
	>
		{highlightSearchMatch(stripHtmlTags(label), searchMatch)}
	</Linkable>
);
